import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsBB: CultureInfo = {
  name: 'es-BB',
  displayName: 'español (Barbados)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-BB',
  parent: CultureInfoEs
};
